import React from 'react';

interface SidebarButtonProps {
    icon: React.ReactNode;
    label: string;
    isCollapsed: boolean;
    onClick?: () => void;
}

const SidebarButton: React.FC<SidebarButtonProps> = ({ icon, label, isCollapsed, onClick }) => {
    return (
        <button
            className={`cursor-pointer m-0 flex items-center gap-3 p-2 hover:bg-[#e1e1e1] text-secondary overflow-hidden transition-all duration-300 ${
                isCollapsed ? 'lg:justify-center mb-[15px] rounded-full w-10 h-10' : 'w-full rounded-lg'
            }`}
            title={isCollapsed ? label : ''}
            onClick={onClick}
        >
            <span className={`transition-all duration-300 ${isCollapsed ? 'scale-125' : 'scale-100'}`}>{icon}</span>
            <span
                className={`text-sm whitespace-nowrap transition-all duration-300 ${!isCollapsed ? 'opacity-100 w-auto ml-0' : 'opacity-0 w-0 -ml-2'}`}
            >
                {label}
            </span>
        </button>
    );
};

export default SidebarButton;
